export {
  resolveProfileForAsk,
  profileConfigFromResolved,
} from "./resolveProfileForAsk.js";
export type {
  AskProfileModelConfig,
  ResolveProfileForAskInput,
} from "./resolveProfileForAsk.js";

export type {
  ResolvedAIProfile,
  InstructionTier,
  AIProfileBackend,
  AIProfileSummary,
  AIProfileChoiceSummary,
  ResolveAIProfileOptions,
  RegistrySourceMode,
  ProfileCatalogLane,
} from "@x12i/ai-profiles";

export { TEXT_CATALOG_LANE } from "./catalogLane.js";

export {
  resolveAIProfile,
  listAIProfiles,
  listAIProfileChoices,
  resolveAIProfileByTags,
  isKnownProfileChoice,
  isKnownProfileChoiceInput,
  isKnownProfileInput,
  isKnownProfileOrShortcut,
  formatProfileChoiceKey,
  listRegistryProfileChoiceKeys,
  ensureConcreteModel,
  resolveBundledInput,
  resolveInput,
  resolveModelIdentity,
  listAICatalogModels,
  resolvePreferOpenRouter,
  readPreferOpenRouterFromEnv,
  parsePreferOpenRouter,
} from "@x12i/ai-profiles";

export type {
  CatalogModelSummary,
  ListAICatalogModelsOptions,
  ResolveInput,
  ResolveInputOptions,
} from "@x12i/ai-profiles";

export {
  profileResolveKey,
  profileResolveKeyFromRegistry,
  requireProfileResolveKey,
  requireProfileResolveKeyFromRegistry,
} from "./profileResolveKey.js";
